<template>
  <v-data-table
    :headers="headers"
    :items="tags"
    :items-per-page="15"
    :page="pageNumber"
    class="elevation-1 tabela-tags"
    locale="pt-BR"
    loading-text="Carregando"
    no-data-text="Nenhum dado encontrado"
    :loading="loading"
    :server-items-length="total"
    @update:options="handleFilter"
    :footer-props="{
      'items-per-page-text': 'Tags por página:',
      'items-per-page-all-text': 'Todos',
      'show-first-last-page': true,
      'show-current-page': true,
      'page-text': pageText,
      'items-per-page-options': [100, 200, 350, 500],
    }"
  >
    <template v-slot:[`body.prepend`]>
      <tr>
        <template v-for="(header, index) in headers">
          <th :key="index">
            <slot :name="header.value"> </slot>
          </th>
        </template>
      </tr>
    </template>

    <template v-slot:[`item.id`]="{ item }">
      <v-menu offset-y v-if="tagEditar || tagExcluir">
        <template v-slot:activator="{ on, attrs }">
          <v-btn small depressed color="fmq_gray" dark v-bind="attrs" v-on="on">
            Opções <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="gotToTags(item.id)" v-if="tagEditar">
            <v-list-item-title>Editar</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$emit('excluir', item)" v-if="tagExcluir">
            <v-list-item-title>Excluir</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "TagsTabela",
  props: {
    headers: {
      type: Array,
      required: true,
    },
    tags: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
    pageText: {
      type: String,
      default: "-",
    },
    pageNumber: {
      type: Number,
      default: 1
    }
  },
  data: () => ({
    formData: {
      orderBy: null,
      orderSorted: null,
      perPage: null,
      page: null,
    },
  }),
  methods: {
    handleFilter(event) {
      (this.formData.orderBy = event.sortBy[0]),
        (this.formData.orderSorted = event.sortDesc[0] ? "DESC" : "ASC"),
        (this.formData.perPage = event.itemsPerPage),
        (this.formData.page = event.page);
      this.$emit("handleFilter", this.formData);
    },
    gotToTags(id) {
      this.$router.push({ name: "TagsEditar", params: { id: id } });
    },
  },
  computed: {
    tagEditar() {
      return this.$store.state.user.data.permissoes.includes(
        "tag.editar"
      );
    },
    tagExcluir() {
      return this.$store.state.user.data.permissoes.includes(
        "tag.excluir"
      );
    },
  },
};
</script>

<style lang="scss">
.tabela-tags tbody tr:nth-of-type(even) {
  background-color: #ffffff;
}

.tabela-tags tbody tr:nth-of-type(odd) {
  background-color: #eeeeee;
}
</style>
